/**
 * Makes nested Firestore client values safe for httpsCallable + Admin writes.
 * Strips `undefined`, converts Timestamp-like values to plain JSON maps.
 */
export const sanitizePlanFirestorePayload = <T>(value: T): T =>
  JSON.parse(JSON.stringify(value ?? null)) as T;

/** Keep first occurrence per id (user id). */
export const dedupeById = <T extends { id?: string | null }>(items: T[]): T[] => {
  const seen = new Set<string>();
  const result: T[] = [];
  items.forEach(item => {
    const id = String(item?.id || '').trim();
    if (!id || seen.has(id)) return;
    seen.add(id);
    result.push(item);
  });
  return result;
};
